/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const einvoice_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M3.75 6.5V2c0-.966.784-1.75 1.75-1.75h10.036a1.75 1.75 0 0 1 1.336.62l4.964 5.866c.267.316.414.716.414 1.13V22a1.75 1.75 0 0 1-1.75 1.75h-15A1.75 1.75 0 0 1 3.75 22v-2.5a.75.75 0 0 1 1.5 0V22c0 .138.112.25.25.25h15a.25.25 0 0 0 .25-.25V7.866a.25.25 0 0 0-.06-.16l-4.963-5.867a.25.25 0 0 0-.19-.089H5.5a.25.25 0 0 0-.25.25v4.5a.75.75 0 0 1-1.5 0Z"
    />
    <path
      fill="#000"
      d="M8.304 13.176c0 .17-.016.315-.048.432h-5.76c.075.65.31 1.152.704 1.504.405.352.917.528 1.536.528.928 0 1.616-.395 2.064-1.184l1.296.912A2.895 2.895 0 0 1 6.8 16.696c-.576.299-1.264.448-2.064.448-.79 0-1.499-.176-2.128-.528a3.787 3.787 0 0 1-1.456-1.472C.811 14.514.64 13.8.64 13c0-.81.16-1.525.48-2.144A3.55 3.55 0 0 1 2.496 9.4c.587-.352 1.259-.528 2.016-.528.768 0 1.435.176 2 .528a3.445 3.445 0 0 1 1.328 1.504c.31.64.464 1.397.464 2.272Zm-3.792-2.8c-.544 0-.992.16-1.344.48-.341.31-.56.763-.656 1.36H6.48c-.107-.597-.33-1.05-.672-1.36-.33-.32-.763-.48-1.296-.48Z"
    />
  </svg>
)
export default einvoice_medium
